"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../themes/colors");
const Button_1 = __importDefault(require("../Button"));
exports.StyledButton = (0, styled_components_1.default)(Button_1.default) `
  height: 48px !important;
  width: 100% !important;

  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 0px 16px !important;
  margin-bottom: 8px !important;

  border: none !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: ${colors_1.colors.black} !important;
  background: white !important;
  outline: none !important;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04) !important;
  border-radius: ${({ theme }) => theme.spacing.unit * 1.5}px !important;
  &:hover {
    filter: brightness(0.9) !important;
  }
`;
//# sourceMappingURL=styled.js.map